import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row p-4 p-md-0" }
const _hoisted_2 = { class: "text-center text-md-start col-12 col-md-4 d-flex flex-column py-md-4 gap-md-4" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "title-4 text-primary-blue" }
const _hoisted_6 = { class: "description" }
const _hoisted_7 = { class: "body text-grey-900" }
const _hoisted_8 = { class: "button" }
const _hoisted_9 = { class: "image-container d-none d-md-block col-md-8" }
const _hoisted_10 = ["src"]

import { computed } from 'vue'

  // UI components
  import Card from '@/components/UI/Card.vue'
  import Button from '@/components/UI/Button.vue'
  import { useDomainRedirect } from '@/composables/useDomainRedirect'
  import YoonlyService from '@/services/YoonlyService'

  // Images
  import bookingPlaceHolder from '@/assets/bookingPlaceHolder.png'
  import bookingPlaceHolderYoonly from '@/assets/YN-booking-placeholder.jpg'

  // Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingPlaceholder',
  props: {
    titleKey: { default: 'reservations.noBooking' },
    descriptionKey: { default: 'reservations.timeToChoose' }
  },
  setup(__props: any) {

  const { t } = useI18n()

  const props = __props

  const placeholderImage = computed(() =>
    new YoonlyService().isYoonly ? bookingPlaceHolderYoonly : bookingPlaceHolder
  )

  // Use the custom redirect composable
  const { handleRedirect } = useDomainRedirect()
  // Updated handleClick method
  const handleClick = (): void => {
    handleRedirect('/se-results', { source: 'my-account' })
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, {
    class: "mb-5",
    "additional-classes": " p-md-0 ps-md-4 pe-md-0 py-md-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "icon")
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(_unref(t)(props.titleKey)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)(props.descriptionKey)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Button, {
              onButtonClick: handleClick,
              classes: ['w-100', 'h-100', 'button-primary', 'bg-primary-blue']
            }, {
              text: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('reservations.search')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: placeholderImage.value,
            alt: "placeholder"
          }, null, 8, _hoisted_10)
        ])
      ])
    ]),
    _: 3
  }))
}
}

})